import { render, staticRenderFns } from "./declareSample.vue?vue&type=template&id=7c5d2448&scoped=true&"
import script from "./declareSample.vue?vue&type=script&lang=js&"
export * from "./declareSample.vue?vue&type=script&lang=js&"
import style0 from "./declareSample.vue?vue&type=style&index=0&id=7c5d2448&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d2448",
  null
  
)

export default component.exports